import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingCustomerAction = (body) => ({
  type : actions.UPDATE_PENDING_CUSTOMER,
  payload : body
})

export const getSinglePendingCustomerAction = (id) => ({
  type: actions.GET_SINGLE_PENDING_CUSTOMER,
  payload: id
})

export const deleteSinglePendingCustomerAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_CUSTOMER,
  payload: id
})

export const moderateCreateSinglePendingCustomerAction = (id,mode) => ({
  type: actions.MODERATE_SINGLE_PENDING_CUSTOMER,
  payload: id,
  mode
})

// Plural
export const getPendingCustomersAction = (body) => ({
  type: actions.GET_PENDING_CUSTOMERS,
  payload: body,
});

/**
 * Actions that are fired by redux-saga watchers
*/

// Singular
export const updatePendingCustomerSuccessAction = (customer) => ({
  type : actions.UPDATE_PENDING_CUSTOMER_SUCCESS,
  payload : customer
})

export const getSinglePendingCustomerSuccessAction = (customer) => ({
  type: actions.GET_SINGLE_PENDING_CUSTOMER_SUCCESS,
  payload: customer
})


export const deleteSinglePendingCustomerSuccessAction = (id) => ({
  type:actions.DELETE_SINGLE_PENDING_CUSTOMER_SUCCESS,
  payload: id
})

export const moderateCreateSinglePendingCustomerSuccessAction = (id) => ({
  type: actions.MODERATE_SINGLE_PENDING_CUSTOMER_SUCCESS,
  payload: id
})

// Plural
export const getPendingCustomersSuccessAction = (customer) => ({
  type: actions.GET_PENDING_CUSTOMERS_SUCCESS,
  payload: customer,
});


/**
 * Misc
 */

export const setPendingCustomersIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_CUSTOMERS_IS_LOADING,
  payload: isLoading,
});

export const setPendingCustomersCountAction = (count) => ({
  type: actions.SET_PENDING_CUSTOMERS_COUNT,
  payload: count,
});
